/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CorrectReleaseRequestEditsInner
 */
export interface CorrectReleaseRequestEditsInner {
    /**
     * 
     * @type {string}
     * @memberof CorrectReleaseRequestEditsInner
     */
    op: CorrectReleaseRequestEditsInnerOpEnum;
    /**
     * 
     * @type {string}
     * @memberof CorrectReleaseRequestEditsInner
     */
    field: string;
    /**
     * 
     * @type {string}
     * @memberof CorrectReleaseRequestEditsInner
     */
    value: string;
}


/**
 * @export
 */
export const CorrectReleaseRequestEditsInnerOpEnum = {
    Edit: 'edit',
    Add: 'add',
    Delete: 'delete'
} as const;
export type CorrectReleaseRequestEditsInnerOpEnum = typeof CorrectReleaseRequestEditsInnerOpEnum[keyof typeof CorrectReleaseRequestEditsInnerOpEnum];


/**
 * Check if a given object implements the CorrectReleaseRequestEditsInner interface.
 */
export function instanceOfCorrectReleaseRequestEditsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function CorrectReleaseRequestEditsInnerFromJSON(json: any): CorrectReleaseRequestEditsInner {
    return CorrectReleaseRequestEditsInnerFromJSONTyped(json, false);
}

export function CorrectReleaseRequestEditsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectReleaseRequestEditsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'op': json['op'],
        'field': json['field'],
        'value': json['value'],
    };
}

export function CorrectReleaseRequestEditsInnerToJSON(value?: CorrectReleaseRequestEditsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'op': value.op,
        'field': value.field,
        'value': value.value,
    };
}

